module.exports = __webpack_public_path__ + "fonts/TTNormsPro-MediumItalic.28edce2b.eot";